import ApiClient from "../../../services/ApiClient2";

const cancelTokens = {
    fetchTemplates: undefined,
    fetchTemplateDetails: undefined,
    fetchIdentifiers: undefined,
}

export function fetchIdentifiers() {
    if (undefined !== cancelTokens.fetchIdentifiers) {
        cancelTokens.fetchIdentifiers = cancelTokens.fetchIdentifiers.cancel();
    }
    cancelTokens.fetchIdentifiers = ApiClient.createCancelToken();
    return ApiClient.query(`/users/available-identities`)
}

export function fetchTemplates() {
    if (undefined !== cancelTokens.fetchTemplates) {
        cancelTokens.fetchTemplates = cancelTokens.fetchTemplates.cancel();
    }
    cancelTokens.fetchTemplates = ApiClient.createCancelToken();
    return ApiClient.query(`/mailbox/template/message/all`, {}, {
        cancelToken: cancelTokens.fetchTemplates.token
    })
}

export function fetchTemplateDetails(templateUuid) {
    if (undefined !== cancelTokens.fetchTemplateDetails) {
        cancelTokens.fetchTemplateDetails = cancelTokens.fetchTemplateDetails.cancel();
    }
    cancelTokens.fetchTemplateDetails = ApiClient.createCancelToken();
    return ApiClient.query(`/mailbox/template/${templateUuid}`, {}, {
        cancelToken: cancelTokens.fetchTemplateDetails.token
    })
}

export function addTemplate(payload) {
    return ApiClient.post(`/mailbox/template/message/`, payload);
}

export function updateTemplate(uuid, payload) {
    return ApiClient.put(`/mailbox/template/${uuid}`, payload);
}

export function deleteTemplate(uuid) {
    return ApiClient.delete(`/mailbox/template/${uuid}`);
}